import React from 'react';
import TextField from '@mui/material/TextField';
import NumberFormat from 'react-number-format';
import _ from 'lodash';

// v9: MUI's Input passes a ref to inputComponent — must be forwardRef-aware,
// otherwise we get the "Function components cannot be given refs" warning.
// react-number-format v4 exposes its inner <input> ref via getInputRef.
export const NumberFormatWrapper = React.forwardRef(function NumberFormatWrapper(props, ref) {
  const { onChange, ...rest } = props;
  return (
    <NumberFormat
      {...rest}
      getInputRef={ref}
      thousandSeparator={true}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value !== '' ? parseFloat(values.value) : undefined
          }
        });
      }}
    />
  );
});

export default class NumberFormatTextField extends React.PureComponent {
  render() {
    const { label, name, value, onChange, inputProps, InputLabelProps, endAdornment, ...rest } = this.props;

    return (
      <TextField
        // MUI v4 defaulted TextField to variant="standard" (underline). MUI v5+/v9
        // changed the default to "outlined", which broke the PDF templates (and the
        // calculator UI): display fields rendered as boxes with the floating label
        // overlapping the value. Restore the v4 default here; placed before {...rest}
        // so any call site can still opt into a different variant.
        variant="standard"
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        slotProps={{
          inputLabel: _.merge({ classes: { root: 'form-label', focused: 'focused' } }, InputLabelProps),
          input: {
            inputComponent: NumberFormatWrapper,
            endAdornment
          },
          htmlInput: {
            ...inputProps,
            'data-lpignore': 'true',
            'data-form-type': 'other'
          }
        }}
        {...rest}
      />
    );
  }
}
